export const FETCH_ONE = 'calendar/FETCH_ONE';
export const FETCH_ONE_SUCCESS = 'calendar/FETCH_ONE_SUCCESS';
export const FETCH_COLLECTION = 'calendar/FETCH_COLLECTION';
export const FETCH_COLLECTION_SUCCESS = 'calendar/FETCH_COLLECTION_SUCCESS';
export const GET_FAVORITES = 'calendar/GET_FAVORITES';
export const GET_FAVORITES_SUCCESS = 'calendar/GET_FAVORITES_SUCCESS';
export const SAVE_FAVORITE = 'calendar/SAVE_FAVORITE';
export const SAVE_FAVORITE_SUCCESS = 'calendar/SAVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE = 'calendar/REMOVE_FAVORITE';
export const REMOVE_FAVORITE_SUCCESS = 'calendar/REMOVE_FAVORITE_SUCCESS';